import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import FilledInput from "@mui/material/FilledInput";
import _ from "lodash";
import {connect} from "react-redux";

import {
    fetchEmailSetting,
    setEmailSetting,
    TRANSACTION_KEY
} from "@/shared/connect_config/actions";
import {ERROR, SUCCESS} from "@/shared/lifecycleStates";
import {clearTransaction} from "@/shared/transaction_state/actions";

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    getEmailSettings: () => dispatch(fetchEmailSetting()),
    saveEmailConfig: (body) => dispatch(setEmailSetting(body)),
    clearTransaction: (key) => dispatch(clearTransaction(key))
})

const useStyles = makeStyles(theme => ({
    panel: {
        marginTop: theme.spacing(1),
    },
    panelHeader: {
        marginLeft: theme.spacing(1)
    },
    domain: {
        whiteSpace: "nowrap",
        color: theme.palette.text.secondary
    },
    inboxNameInput: {
        margin: theme.spacing(1),

    },
    button: {
        margin: theme.spacing(3),
    },
    instructions: {
        margin: theme.spacing(1),
    }
}));

function ManageEmailSettings(props) {
    var {} = props;
    const classes = useStyles();
    const [loadActionsCalled, setLoadActionsCalled] = React.useState(false);
    const inboxNameRef = React.createRef()

    if(!loadActionsCalled){
        props.clearTransaction(TRANSACTION_KEY);
        props.getEmailSettings();
        setLoadActionsCalled(true);
    }

    const saveInbox = () => {
        let configObj = {
            inboxName: inboxNameRef.current.value
        }
        props.saveEmailConfig(configObj);
        props.clearTransaction(TRANSACTION_KEY);
    }

    let error = false;
    if(props.transactions[TRANSACTION_KEY]){
        if(props.transactions[TRANSACTION_KEY].state == ERROR){
            toast(props.transactions[TRANSACTION_KEY].errorMsg, {position: "top-center", type: "error"});
            error = true;
        }
        else if(props.transactions[TRANSACTION_KEY].state == SUCCESS){
            toast.success("Inbox Domain Successfully Claimed!", {position: "top-center"});
            props.clearTransaction(TRANSACTION_KEY);
            props.getEmailSettings();
        }
    }

    return (
        <Grid className={classes.panel} item>
            <Paper elevation={2}>
                <Typography className={classes.panelHeader} variant={"h6"}>Email Settings</Typography>
                <Divider></Divider>
                <Typography className={classes.instructions} color={"textSecondary"}>Below is the email you should give clients if they want to email in with requests. Choose something like your clinic's name. Once it is received you will have an opportunity to route it to the correct person</Typography>
                <FormControl className={classes.inboxNameInput}>
                    <InputLabel>Inbox Name</InputLabel>
                    <FilledInput
                        error={error}
                        inputRef={inboxNameRef}
                        defaultValue={_.get(props, "connectConfig.email.inboxName")}
                        endAdornment={<InputAdornment className={classes.domain} position="end">@{_.get(props, "connectConfig.email.domain")}</InputAdornment>}
                    />
                </FormControl>
                <Button variant="contained" color="primary" className={classes.button} onClick={saveInbox}>
                    Save
                </Button>
            </Paper>
        </Grid>
    )

}

export default connect(mapStateToProps, mapDispatchToProps)(ManageEmailSettings);